import { useStore } from 'vuex'

export default {
    name: 'SignUpButton',
    props: {
        eventId: {
            type: String,
            required: true
        },
        successButtonData: {
            type: Object,
            required: false
        }
    },
    setup(props) {
        const store = useStore()
        const startSignUp = function (e) {
            if (!props.eventId) return false

            store.commit('events/set_signUpEventId', props.eventId)
            store.commit('main/set_page_overlay_content_data', {
                successButtonData: props.successButtonData
            })

            store.dispatch('main/openPageOverlay', {
                overlayContent: 'SignUpForm',
                returnTarget: e.currentTarget
            })
        }

        return {
            startSignUp
        }
    }
}
